module.exports = __webpack_public_path__ + "static/media/early-birds.8531374b.svg";